import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Toaster } from 'ngx-toast-notifications';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import confirmPassword from '../../../helpers/validationMessages/confirmPassword';
import email from '../../../helpers/validationMessages/email';
import login from '../../../helpers/validationMessages/login';
import password from '../../../helpers/validationMessages/password';
import terms from '../../../helpers/validationMessages/terms';
import username from '../../../helpers/validationMessages/username';
import { LanguageService } from '../../../language.service';
import { User } from '../../../models/user';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginFormComponent implements OnInit, OnDestroy {

  @Output() infoAsked = new EventEmitter<boolean>();
  @Output() loginAsked = new EventEmitter<Object>();

  private submitted: boolean = false;
  public hide: boolean = true;
  private loading: boolean = false;
  private returnUrl: string;
  private error: any;

  // Toaster Params
  private title: string;
  private text: string;
  private type: any;

  private loginSub: Subscription;
  private _translation: Subscription;

  loginDetailsForm: FormGroup;

  account_validation_messages = {
    username: username.username,
    confirmPassword: confirmPassword.confirmPassword,
    email: email.email,
    login: login.login,
    password: password.password,
    terms: terms.terms
  }

  toasterMessage: string = '';
  toasterCaption: string = '';
  toasterErrorCaption: string = '';
  toasterErrorMessage: string = '';

  role: string = '';

  errorMessage: string = '';

  constructor(
    private languageService: LanguageService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private toaster: Toaster) {
  }

  ngOnInit() {
    this.createForms();
  }

  createForms() {

    // user links form validations
    this.loginDetailsForm = this.fb.group({
      username: new FormControl('', Validators.compose([
        // UsernameValidator.validUsername,
        Validators.maxLength(25),
        Validators.minLength(5),
        // Validators.pattern('^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
        Validators.required
      ])),
      password: new FormControl('', Validators.compose([
        // PasswordValidator.areEqual,
        Validators.minLength(5),
        Validators.required,
        // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
        // Validators.pattern('^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).*$')
      ])),
    })
  }

  submit(value: any) {
    let username = this.loginDetailsForm.value.username;
    let password = this.loginDetailsForm.value.password;
    let loginObject: User = {
      username,
      password
    }

    this.loginSub = this.authService.login(loginObject)
      .subscribe(
        data => {
          this.loading = true;
          if (data) {
            this.loading = false;
            if (this.route.snapshot.queryParams.returnUrl !== undefined) {
              this.router.navigate([this.route.snapshot.queryParams.returnUrl]);
            } else this.router.navigate(['home/dashboard']);
          }
          this.role = data.role;
          this.getToasterTranslation()
          this.toaster.open({ text: this.toasterMessage, caption: this.toasterCaption, type: 'success' })
        },
        error => {
          this.error = error;
          console.log(this.error)
          for (let err in this.error) {
            if (this.error[err] == "Unable to log in with provided credentials.") {
              this.getToasterTranslation()
              this.toaster.open({
                caption: this.toasterErrorCaption,
                text: this.toasterErrorMessage,
                type: 'warning',
                duration: 10_000,
                position: 'bottom-center'
              })
            } else {
              this.toaster.open({
                text: this.error[err],
                type: 'warning',
                duration: 10_000,
                position: 'bottom-center'
              })
            }
          }
        });
  }

  //User successfully logged in with role admin

  getToasterTranslation() {
    this._translation = this.languageService.currentLanguage.pipe(distinctUntilChanged()).subscribe(res => {
      this.translateService.get('LOGIN_SUCCESS_MESSAGE', { role: this.role }).subscribe((message: string) => {
        this.toasterMessage = message;
      })

      this.translateService.get('LOGIN_SUCCESS_CAPTION').subscribe((caption: string) => {
        this.toasterCaption = caption;
      })

      this.translateService.get('LOGIN_ERROR_MESSAGE').subscribe((message: string) => {
        this.toasterErrorMessage = message;
      })

      this.translateService.get('LOGIN_ERROR_CAPTION').subscribe((caption: string) => {
        this.toasterErrorCaption = caption;
      })

      this.translateService.get('LOGIN.LOGIN_ERROR_WOOPS').subscribe((caption: string) => {
        this.toasterErrorCaption = caption;
      })

      this.translateService.get('LOGIN.LOGIN_ERROR_PROVIDE_CREDENTIALS').subscribe((message: string) => {
        this.toasterErrorMessage = message;
      })
    })
  }

  // getErrorToasterTranslation() {
  //   this._translation = this.languageService.currentLanguage.pipe(distinctUntilChanged()).subscribe(res => {
  //     this.translateService.get('LOGIN_ERROR_MESSAGE').subscribe((message: string) => {
  //       this.toasterErrorMessage = message;
  //     })

  //     this.translateService.get('LOGIN_ERROR_CAPTION').subscribe((caption: string) => {
  //       this.toasterErrorCaption = caption;
  //     })
  //   })
  // }

  infoShow(agreed: boolean) {
    this.infoAsked.emit(agreed);
  }

  ngOnDestroy() {
    if (this.loginSub) this.loginSub.unsubscribe();
  }

}
